
export default {
  name: 'Advantages',
  computed: {
    list() {
      return this.$t('advantages.list')
    },
  },
}
